/* eslint-disable eqeqeq */
import BoxStaff from "./BoxStaff";
import BoxStaffCard from "./BoxStaffCard";
import ExpandButton from "./ExpandButton";
import ExpandButtonOnlyRole from "./ExpandButtonOnlyRole";

const SmallBoxChart = (data, users, userDetails, type, addon) => {
  const normalizedAddon = addon && typeof addon === "object" ? addon : {};

  const {
    exclude_top_level: excludeTopLevel = false,
    level = 0,
    elem_id: elemId = "",
    count_child_dept: childDeptCount = 0,
    is_hide_division: isHideDivision = false,
    user_id: userId = "",
    isShowFullnameAndPosition = false } = normalizedAddon;

  const boxContent = [];
  let divClass = "";
  let btnExpend = "";
  let divBadge = "";

  const isExpandedDefault =
    !isHideDivision ||
    "is_org" in data ||
    ("level_id" in data && data.level_id < 1);

  if (childDeptCount > 0 || (users.length > 0 && type !== "functional")) {
    divClass = " level div-dept";
    btnExpend = ExpandButton({ elemId, isExpanded: isExpandedDefault });
    divBadge =
      '<span class="new badge" data-badge-caption="" style="display: none;"></span>';
  }

  if (type == "functional") {
    boxContent.push(
      `<div class="level-` +
        level +
        divClass +
        `"><span>` +
        data.name +
        btnExpend +
        `</span></div>`
    );
  } else if (type === "role") {
    const btnExpendOnlyRole = ExpandButtonOnlyRole({
      elemId,
      isActive: isExpandedDefault,
      count: addon.countUserChildren ?? 0 });

    const staffMarkup = isShowFullnameAndPosition
      ? BoxStaffCard({
          data,
          level,
          addon: { class: userId && data.idu == userId ? " active" : "" } })
      : BoxStaff({
          data,
          level,
          addon: { class: userId && data.idu == userId ? " active" : "" } });

    if (data.is_top_level == 1) {
      boxContent.push(
        `<div class="box-include-top-level role-chart top-level-${level}">`,
        staffMarkup,
        btnExpendOnlyRole,
        `</div>`
      );
    } else {
      //   boxContent.push(`<div class="role-card">`, staffMarkup, `</div>`);
      boxContent.push(staffMarkup, btnExpendOnlyRole);
    }
  } else if (type === "staff") {
    if (users.length === 0) return "";

    const listItems = users
      .map((key) => userDetails[key])
      .filter((detail) => !(detail.is_top_level == 1 && detail.level <= 6))
      .map((detail) =>
        isShowFullnameAndPosition
          ? `<li>${BoxStaffCard({ data: detail, level: level + 1 })}</li>`
          : `<li>${BoxStaff({ data: detail, level: level + 1 })}</li>`
      );

    if (!listItems.length) return "";
    boxContent.push(listItems.join(""));
  } else {
    const topStaff =
      users.length > 0 && userDetails[users[0]].is_top_level === 1;

    const nameBlock =
      `<div class="level-${level}${divClass}"><span>` +
      data.name +
      btnExpend +
      divBadge +
      `</span></div>`;

    if (!excludeTopLevel && topStaff) {
      boxContent.push(
        `<div class="box-include-top-level top-level-${level}">`,
        nameBlock
      );

      const staffNodes = users
        .map((key) => userDetails[key])
        .filter((detail) => detail.is_top_level !== 0 || detail.level <= 6)
        .map((detail) =>
          isShowFullnameAndPosition
            ? BoxStaffCard({
                data: detail,
                level,
                addon: {
                  class: `staff-top-level${
                    elemId ? ` sub-dept-${elemId}` : ""
                  }`,
                  css: isHideDivision ? "display: none;" : "" } })
            : BoxStaff({
                data: detail,
                level,
                addon: {
                  class: `staff-top-level${
                    elemId ? ` sub-dept-${elemId}` : ""
                  }`,
                  css: isHideDivision ? "display: none;" : "" } })
        );

      if (staffNodes.length > 0) {
        boxContent.push('<div class="outer-staff-top-level">');
        boxContent.push(...staffNodes);
        boxContent.push("</div>");
      }
      boxContent.push("</div>");
    } else {
      boxContent.push(nameBlock);
    }
  }

  return boxContent.join("");
};

export default SmallBoxChart;

